import { Col, Flex, Form, Modal, ModalProps, Row } from 'antd';
import { ChangeEvent, memo, useCallback } from 'react';

import { Button, InputForm } from 'components';
import FormItem from 'antd/es/form/FormItem';
import TextArea from 'antd/es/input/TextArea';

type IDealPriceModalProps = {
  currentMarketGoldPrice: number;
  onOk(formValues: any): void;
  onCancel: () => void;
} & Omit<ModalProps, 'onOk' | 'onCancel'>;

const DealPriceModal = memo(
  ({
    open,
    loading,
    currentMarketGoldPrice,
    onOk,
    onCancel,
  }: IDealPriceModalProps) => {
    const [form] = Form.useForm();

    const handleOnOk = useCallback(async () => {
      if (!(await form.validateFields())) return;

      const values = form.getFieldsValue();

      onOk({
        ...values,
        dealPrice: Number(values?.dealPrice?.replace(/\D/g, '')),
        salePrice: Number(values?.salePrice?.replace(/\D/g, '')),
      });
    }, [onOk]);

    const handleOnCancel = useCallback(() => {
      form.resetFields();
      onCancel && onCancel();
    }, [onCancel]);

    const handleDealPriceChange = (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      const formattedValue = Number(value.replace(/\D/g, ''));

      form.setFieldValue('dealPrice', formattedValue?.toLocaleString('vi-VN'));
    };

    return (
      <Modal
        title="Thương lượng giá bóng"
        open={open}
        className="min-w-[600px]"
        onCancel={handleOnCancel}
        footer={
          <Flex align="center" justify="end" gap={4}>
            <Button
              type="button"
              title="Quay lại"
              handleOnclick={handleOnCancel}
            />
            <Button
              fill
              title="Gửi duyệt"
              handleOnclick={() => form.submit()}
              disabled={loading}
            />
          </Flex>
        }
      >
        <Form layout="vertical" form={form} onFinish={handleOnOk}>
          <Row gutter={{ xs: 8, sm: 14 }}>
            <Col span={12}>
              <FormItem
                label="Giá bóng hiện tại"
                name="salePrice"
                initialValue={currentMarketGoldPrice?.toLocaleString('vi-vn')}
              >
                <InputForm readOnly placeholder="Nhập giá bóng" />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem
                label="Giá bóng thỏa thuận"
                name="dealPrice"
                rules={[
                  {
                    required: true,
                    message: 'Vui lòng nhập giá bóng thỏa thuận',
                  },
                ]}
              >
                <InputForm
                  placeholder="Nhập giá bóng"
                  onChange={handleDealPriceChange}
                />
              </FormItem>
            </Col>
          </Row>
          <FormItem name="note" label="Ghi chú">
            <TextArea placeholder="Nhập ghi chú" />
          </FormItem>
        </Form>
      </Modal>
    );
  },
);

export default DealPriceModal;
